import loadAnalytics from "./Analytics"
import TrackPage from "./TrackPage"

export default loadAnalytics
export { TrackPage }
